




















































import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import SelectSessionBtn from "@/views/customize/data-sources/modals/source-details/SelectSessionBtn.vue";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import { UseModal } from "@/components/root/modal";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import Search from "@/components/Search.vue";
import FilesInformationView from "./files-information/FilesInformationView.vue";
import FilesSearchView from "./files-search-page/FilesSearchView.vue";
import WalkthroughModalVue from "@/components/modals/walkthrough-modal/WalkthroughModal.vue";

export default Vue.extend({
  components: {
    PageWithMainContainer,
    SelectSessionBtn,
    //  SimpleNavTabs,
    //  Search,
    FilesInformationView,
    FilesSearchView,
  },
  setup() {
    const {
      loading,
      selected_session,
      sessions,
      set_selected_session,
      root_folders,
      current_root_folder,
      change_root_folder,
      search,
    } = state;

    const { isSearching: is_searching, query } = search;

    const open_new_session_modal = async () => {
      UseModal().show(WalkthroughModalVue, {
        id: "onprem_fs.session",
        height: "50rem",
      });
    };

    onMounted(() => {
      state.init();
    });

    onBeforeUnmount(() => {
      state.destroy();
    });
    return {
      loading,
      selected_session,
      sessions,
      set_selected_session,
      open_new_session_modal,
      root_folders,
      current_root_folder,
      change_root_folder,
      is_searching,
      query,
    };
  },
});
